import React, { useState, useEffect } from "react"
import { InputText_s } from 'styles/input-styles'

type ITextInput = {
  attrs?: Function
  id?: string
  className?: string
  disabled?: boolean
  defaultValue?: string
  field?: string
  value: string
  persist: Function
}

const TextInput = (props: ITextInput) => {
  const [value, setValue] = useState<string>(props.value)

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  const attrs = (props.attrs && !props.disabled) ? props.field ? props.attrs(props.field) : props.attrs() : {}

  return (
    <InputText_s
      type="text"
      className={props.className}
      disabled={props.disabled}
      defaultValue={props.defaultValue}
      value={value}
      onChange={(e) => setValue((e.target as HTMLInputElement).value)}
      onBlur={() => props.persist(value)}
      {...attrs}/>
  )
}

export default TextInput
